import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { IReactionModel, IReactionSaveModel } from '@fi-shared/fi-likes/fi-likes';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Injectable()
export class FiLikesService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private userDataService: FiUserDataService,
    ) {}

    saveLike(likeToSave: IReactionSaveModel) {
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost('Core/Reaction/SaveReaction', likeToSave));
    }

    deleteLike(likeToDelete: IReactionSaveModel) {
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost('Core/Reaction/DeleteReaction', likeToDelete));
    }

    getCurrentUsersLike(likes: IReactionModel[]): IReactionModel {
        return likes.find((like) => like.UserId == this.userDataService.getUserId());
    }

    isCurrentUserLiked(likes: IReactionModel[]): boolean {
        return !!this.getCurrentUsersLike(likes);
    }

    getLikesCount(likes: IReactionModel[]): number {
        return likes.length;
    }
}
